import { Root, Content, Trigger } from '@radix-ui/react-collapsible';
import classNames from 'classnames';
import { type PropsWithChildren } from 'react';

import styles from './Сollapsible.module.scss';

export const CollapsibleContent = ({
  duration = 300,
  children,
}: PropsWithChildren<{ duration?: number }>) => {
  return (
    <Content
      className={styles.content}
      style={{
        animationDuration: `${duration}ms`,
      }}
    >
      {children}
    </Content>
  );
};

export const CollapsibleTrigger = ({
  className,
  ...props
}: React.ComponentPropsWithRef<typeof Trigger>) => (
  <Trigger className={classNames(styles.trigger, className)} {...props} />
);

export { Root as Collapsible };
